import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import type { AiAssistantPageContext } from '@asset-metrix/portal-ui';

import { useNavigationQuery } from '../../api/portalGateway/navigation';
import { useGetDynamicNavData } from '../navigation/useNavigationCustomizationQuery';

import { resolveCurrentPage } from './pageContext';

export function useCurrentPage(): AiAssistantPageContext {
  const location = useLocation();
  const { '*': slug } = useParams();
  const { data } = useNavigationQuery();
  const { navItems: dynamicNavItems } = useGetDynamicNavData();

  return useMemo(
    () =>
      resolveCurrentPage({
        pathname: location.pathname,
        search: location.search,
        slug,
        navTree: data?.rootNavigationItems ?? [],
        dynamicNavItems,
      }),
    [
      data?.rootNavigationItems,
      dynamicNavItems,
      location.pathname,
      location.search,
      slug,
    ]
  );
}
